module.exports = __webpack_public_path__ + "static/media/img_3.e5499ab2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/img_3.jpg
// module id = 543
// module chunks = 0